import { Box } from '@mui/material'
import { Player } from '@lottiefiles/react-lottie-player'
import { useI18n } from '@ggs/i18n'
import LoadingAnimation from './LoadingAnimation.json'
import './ResultsLoading.scss'

const ResultsLoading = () => {
  const { t } = useI18n()
  return (
    <Box className="results-loading">
      <Player
        src={LoadingAnimation}
        aria-labelledby={t('Searching...')}
        autoplay={true}
        loop={true}
        speed={2}
        style={{ width: '64px', height: '64px' }}
      />
    </Box>
  )
}

export default ResultsLoading
